/**
 * A function to create the mutations to set the min last price update
 * as a global app setting in the store and to load it from the local storage.
 * 
 * @param {Object} [storage] generated with the `createNamespacedLocalStorageFunctions`
 *  function present in the `local-storage` file in the store directory. Is an optional
 *  parameter to store the value of this mutation in the local storage with the namespace
 *  of the correspondent module of the store.
 * 
 * @returns {Object} with the mutation to set the value in the store and another mutation
 *  to load the value from the local storage.
 */
export default storage => {
  const storageKey = 'appSettingsMinLastPriceUpdate';


  /**
   * AVOID USING THIS MUTATION DIRECTLY. Please use the action with the same name.
   *
   * Set a date to get items with `lastPriceUpdate` greater or equal to this one.
   *
   * @param {OBject} state
   * @param {String} date in format YYYY-MM-DD
   */
  function setAppSettingsMinLastPriceUpdate(state, date) {
    if (date && !(/^\d{4}-\d{2}-\d{2}$/.test(date))) {
      throw new Error('The date must match the pattern YYYY-MM-DD')
    }

    state.appSettings.minLastPriceUpdate = date
    if (storage && date) {
      storage.setItem(storageKey, date)
    } else {
      storage.removeItem(storageKey)
    }
  }


  /**
   * Load the `minLastPriceUpdate` setting from the local storage and set it
   * in the store.
   *
   * @param {Object} state
   */
  function loadAppSettingsMinLastUpdateFromStorage(state) {
    const date = storage.getItem(storageKey)

    if (date) {
      setAppSettingsMinLastPriceUpdate(state, date);
    }
  }


  return {
    loadAppSettingsMinLastUpdateFromStorage,
    setAppSettingsMinLastPriceUpdate
  }
}
